module.exports = __webpack_public_path__ + "static/media/menu_arte-publica.068c2610.png";